import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { theme } from "../../styles/themes/mainTheme";

interface UserStatusDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onToggleUserStatus: () => void;
  isUserLocked: boolean;
}

const UserStatusDialog = ({
  isOpen,
  onClose,
  onToggleUserStatus,
  isUserLocked,
}: UserStatusDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
    >
      <DialogTitle>
        {isUserLocked ? t("table.user.activateAccount") : t("table.user.deactivateAccount")}
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {isUserLocked ? t("table.user.activateAccountConfirmationText") : t("table.user.deactivateAccountConfirmationText")}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            color: theme.palette.text.secondary,
          }}
        >
          {t("table.user.cancel")}
        </Button>
        <Button onClick={onToggleUserStatus} autoFocus>
          {t("table.user.continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserStatusDialog;
